// Shared GTM click tracking, reusable by any dataLayer event: give it a
// selector and a function that builds the payload for the clicked element.
//
// A link waits for GTM to acknowledge the push before navigating, with a
// timeout so a slow or blocked container never stops the hand-off. A link that
// opens a new tab is left to the browser: this page stays open, so GTM still
// sends the event, and navigating from the callback would lose the target.
// Nothing is pushed - and no click intercepted - when the container is absent.
export function pushDataLayerEvent(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

export function parsePayload(json) {
  try {
    return JSON.parse(json || '{}');
  } catch {
    return {};
  }
}

function handleClick(el, payload) {
  const { href } = el;

  pushDataLayerEvent({
    ...payload,
    eventCallback() { if (href) window.location = href; },
    eventTimeout: 2000,
  });
}

function opensNewTab(el) {
  return el.target === '_blank';
}

export default function trackClicks(selector, buildPayload) {
  document.addEventListener('click', e => {
    const el = e.target.closest(selector);
    if (!el || !window.google_tag_manager) return;

    // Nothing to track: leave the click to behave as though we were never here.
    const payload = buildPayload(el);
    if (!payload) return;

    if (opensNewTab(el)) {
      pushDataLayerEvent(payload);
      return;
    }

    e.preventDefault();
    handleClick(el, payload);
  });
}
